<ng-container>
<div class="prompt-section">
    <!-- Domain switch: above text area when not new chat; fixed at caret when new chat -->
    <div class="domain-switch-container" [class.domain-switch-above-input]="!isNewChat"
      *ngIf="isDomainManagementEnabled && allDomainNames?.length && agentId === 'regulations_agent'">
      <app-domain-switch
        [textareaElement]="textareaElementForDomainSwitch"
        [allDomainNames]="allDomainNames"
        [isNewChatbotEnabled]="true"
        (suggestionSelected)="suggestionSelected.emit($event)"
        (domainInserted)="onDomainInserted()"
        (suggestionsVisible)="isDomainDropdownOpen = $event">
      </app-domain-switch>
    </div>
  <!-- Text Area Input -->
  <div class="input-wrapper">
    <div class="form-input">
      <div
        #promptTextarea
        class="form-prompt"
        (keydown)="onEnterPress($event)"
        [(ngModel)]="txtChat"
        [attr.data-placeholder]="inputPlaceholder"
        id="text_area"
        contenteditable="true">
      </div>
      
      <!-- Actions: Retrieval mode toggle + Mic + Send (beside each other at bottom-right) -->
      <div class="prompt-actions" >
        <app-retrieval-mode-toggle
          *ngIf="isRetrievalModeFeatureEnabled && agentId === 'regulations_agent'"
          [showLabel]="true">
        </app-retrieval-mode-toggle>
        <div class="voice-input-container"
          [ngClass]="{ 'visible': micActive || !txtChat, 'hidden': !micActive && txtChat }">
          <app-voice-input 
            (speechText)="onMicSpeechUpdate($event)" 
            (micStatus)="onMicStatusUpdate($event)"
            (speechError)="onMicSpeechError($event)"></app-voice-input>
        </div>
        <div class="btn-chat-send-container">
          <button class="btn-chat-send"
                  (click)="sendMessage()"
                  [disabled]="loaderShow || !txtChat.trim()">
            <i class="fa-solid fa-arrow-up"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
  
  <!-- Prompt Library Cards (shown only when available and new chat) -->
  <div class="prompt-cards-prompt-library"  *ngIf="promptLibrary && promptLibrary.length > 0 && isNewChat">
    <div class="prompt-cards" >
      <div 
        class="prompt-card" 
        *ngFor="let prompt of promptLibrary"
        (click)="onPromptClick(prompt)">
        <div class="prompt-card-heading" *ngIf="agentId === 'regulations_agent' || agentId === 'via_agent'">
          <img *ngIf="prompt?.title === 'REG_RADAR_TITLE' || prompt.title === 'SUGGESTED_PROMPT_HEADING'" src="../../../assets/icons/icon-regradar.svg" alt="RegRadar" class="prompt-card-heading-image" />
          <img *ngIf="prompt.title === 'EXPERT_CURATED_QUESTIONS_TITLE'" src="../../../assets/icons/icon-expert-curated-questions.svg" alt="RegSelect" class="prompt-card-heading-image"/>
          <h6 class="prompt-card-heading-content">{{(prompt?.title || "")| translate}}</h6>
        </div>
        <p *ngIf="prompt?.literalContent">{{ prompt.prompt }}</p>
        <p *ngIf="!prompt?.literalContent">{{ (prompt?.prompt||"")| translate }}</p>
      </div>
    </div>
    <div  class="prompt-library-button-container">
      <button  class = "prompt-library-button" (click) = "onPromptLibrary()">
        <span class="prompt-library-button-image" aria-hidden="true"></span>
        {{'PROMPT_LIBRARY_BUTTON'| translate}}
      </button>
      </div>
  </div>
</div>
  <!-- Prompt Library overlay: full app-prompt-library popup -->
  <div class="prompt-overlay" *ngIf="PromptLibraryPopup" tabindex="-1" (click)="PromptLibraryPopup = false" (keydown)="onPromptOverlayKeydown($event)">
    <div class="prompt-popup-wrapper" (click)="$event.stopPropagation()" (keydown)="onPromptPopupWrapperKeydown($event)">
      <app-prompt-library
        [toggledDbDataset]="selectedVectorDbDataset"
        [selectedVectorDbDataset]="selectedVectorDbDataset"
        [vectorDbDatasets]="vectorDbDatasets"
        [loaderShow]="loaderShow"
        [IsResponseStreaming]="IsResponseStreaming"
        [domainName]="domainName"
        [tenantId]="tenantId"
        [userId]="userId"
        [isAgent]="true"
        [isRegRader] = "isRegRader"
        [isRegSelect] = "isRegSelect"
        [agentName]="agentId"
        (uploadQuestionSelected)="onPromptLibraryQuestionSelected($event)"
        (sendRequestEmitted)="onSendRequestFromPromptLibrary()"
        (close)="PromptLibraryPopup = false"
        (newSelectedDataset)="promptLibraryNewSelectedDataset.emit($event)"
        (clickNewChatFunc)="promptLibraryClickNewChat.emit($event)"
        (scrollBottom)="promptLibraryScrollBottom.emit()">
      </app-prompt-library>
    </div> 
  </div>
</ng-container>


 

